import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { TextField, Typography } from "@mui/material";
import LogPopover from "Components/UI/Popovers/LogPopover";

export default function LogForm({ handlePost, entityID, checkboxInfo, logs }) {
  const [checked, setChecked] = useState(false);
  const [message, setMessage] = useState("");

  const handleOnClick = () => {
    if (message.length > 0) {
      handlePost({
        EntityId: entityID,
        Message: message,
        Hidden: checked ? 0 : 1,
      });
      setMessage("");
      setChecked(false);
    }
  };
  return (
    <>
      <Grid
        container
        spacing={8}
        direction="row"
        alignItems="flex-start"
        paddingX={3}
        justifyContent="flex-start"
      >
        <Grid item xs={6} sm={6} md={6}>
          <Grid item md={12} sx={{ display: "flex", mt: 3 }}>
            <Typography variant="subtitle2">Skapa loggmeddelande</Typography>
          </Grid>
          <TextField
            variant="outlined"
            label="Innehåll"
            multiline
            fullWidth
            margin="dense"
            rows={5}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            {checkboxInfo && (
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={() => setChecked(!checked)}
                      inputProps={{ "aria-label": "controlled" }}
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
                    />
                  }
                  label="Visa för klient"
                />
              </FormGroup>
            )}
            <Button onClick={() => handleOnClick()} variant="contained">
              Spara
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <Grid item md={12} sx={{ display: "flex", mt: 3 }}>
            <Typography variant="subtitle2">Manuellt skapade loggar</Typography>
          </Grid>
          <LogPopover
            logs={logs?.filter(
              (log) => log.UserAction === "Skapat logg manuellt"
            )}
            maxWidth={"100%"}
          />
        </Grid>
      </Grid>
    </>
  );
}
